module.exports = __webpack_public_path__ + "static/media/lb_04 (1).0a2b94ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lb_04 (1).jpg
// module id = 2007
// module chunks = 2